export default {"src":"/_next/static/image/public/images/flags/flag_376.3aa92cdaff47daddab641069d92d75f2.svg","height":16,"width":25};